// export const usersInStoreTableWidths = {
//   user: 400,
//   role: 230 //px
// }
export const usersInStoreTableWidths = {
  user: 600,
  role: 600, //px
  assignStore : 554
}